import { Button, Skeleton, Typography } from "@mui/material";
import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useParams } from "react-router-dom";
import IResponse from "../../interfaces/response";
import CarType from "../../interfaces/car";
import { useReactToPrint } from "react-to-print";
import ListSkeleton from "../core/ListSkeleton";

export default function Print() {
    const { id } = useParams();
    const { t } = useTranslation();
    const { state } = useLocation();
    const [car, setCar] = useState<CarType>(state?.car);
    const contentRef = useRef<HTMLDivElement>(null);
    const handlePrint = useReactToPrint({ content: () => contentRef.current });

    useEffect(() => {
        if (car?.id !== Number(id)) {
            axios<IResponse<CarType>>({
                url: `/car/${id}`,
            }).then(res => {
                if (res.data.success) {
                    setCar(res.data.data);
                }
            })
        }
    }, [id]);

    return (
        <div>
            <div className="flex justify-center mb-5">
                <Button onClick={handlePrint} variant="contained" className="mx-auto">{t('print')}</Button>
            </div>
            <div style={{backgroundImage: 'url("/bg.jpg")', height: '21cm', width: '29.7cm', backgroundSize: '100%'}} className="relative">
                <div style={{direction:'rtl'}} ref={contentRef} >
                    <Typography style={{ position: 'absolute', top: '4.6cm', right: '3cm', width: '2cm' }}>{car?.register_date ? new Date(car.register_date).toLocaleDateString('fa-IR') : <Skeleton />}</Typography>
                    <Typography style={{ position: 'absolute', top: '5.4cm', right: '3cm', width: '1.7cm' }}>{car?.register_date ? new Date(car.register_date).toLocaleTimeString('fa-IR', {hour: '2-digit', minute: '2-digit'}) : <Skeleton />}</Typography>
                    <Typography style={{ position: 'absolute', top: '5.4cm', right: '3cm', width: '1.7cm' }}>{car?.register_date ? new Date(car.register_date).toLocaleTimeString('fa-IR', {hour: '2-digit', minute: '2-digit'}) : <Skeleton />}</Typography>
                    <Typography style={{ position: 'absolute', top: '4.6cm', right: '6.3cm', width: '0.9cm' }}>{car?.license_plate_iran_code ?? <Skeleton />}</Typography>
                    <Typography style={{ position: 'absolute', top: '4.6cm', right: '8.2cm', width: '3cm' }}>{car?.license_plate ?? <Skeleton />}</Typography>
                    <Typography style={{ position: 'absolute', top: '5.4cm', right: '7.2cm', width: '4cm' }}>{car?.type ?? <Skeleton />}</Typography>
                    <Typography style={{ position: 'absolute', top: '4.6cm', right: '15.4cm', width: '2.1cm' }}>{car?.chassis ?? <Skeleton />}</Typography>
                    <Typography style={{ position: 'absolute', top: '5.4cm', right: '14cm', width: '3cm' }}>{car?.color ?? <Skeleton />}</Typography>
                    <Typography style={{ position: 'absolute', top: '6.3cm', right: '1.6cm', width: '15.5cm', lineHeight: '1.14cm', fontFamily: 'IranNastaliq', fontSize: 20 }}>{car?.body_description ?? <ListSkeleton count={2} />}</Typography>
                    {/* <Typography style={{ position: 'absolute', top: '9.7cm', right: '1.6cm', width: '15.5cm', lineHeight: '1.14cm' }}>{car?.chassis_description ?? <ListSkeleton count={2} />}</Typography> */}
                    <Typography style={{ position: 'absolute', top: '15.6cm', right: '3.2cm', width: '14.4cm', fontSize: 12}}>{car?.public_description }</Typography>
                </div>
            </div>
        </div>
    )
}
